/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { usePostData } from "../customHooks/usePostData";

interface PageTrackerProps {
  children: React.ReactNode;
}

const PageTracker = ({ children }: PageTrackerProps) => {
  const { isAuthenticated } = useAuth0();

  const { mutate: trackPage } = usePostData(
    `/user-analytics/track-user-page-visits/`,
    "POST"
  );

  useEffect(() => {
    const sendPageView = async () => {
      if (!isAuthenticated) return;

      try {
        trackPage(
          { page_url: window.location.pathname },
          {
            onSuccess: () => {
              console.log("Page view recorded:", window.location.pathname);
            },
            onError: (err: any) => {
              console.error("Failed to record page view:", err);
            },
           
          } 
        );
      } catch (error) {
        console.error("Error getting token for page tracking:", error);
      }
    };

    sendPageView();
  }, [isAuthenticated, trackPage]);

  return <>{children}</>;
};

export default PageTracker;
